<template>
    <div>

        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>


        <!-- <em class="mb-4 text-danger"  v-if="! isLoadingBlade">
            Kindly fill your College of Medicine details first, before updating
            other educational records.
        </em> -->


        <hr class="my-4"  v-if="! isLoadingBlade"/>

        <!-- import edu records details template here -->
        <EduRecordsData
            :eduRecords="eduRecords"
            :showAddRecord="showAddRecord"
            v-on:deleteEduRecord="deleteEduRecord"
            :pagination="pagination"
            :hasPagination="hasPagination"
            :paginate="paginate"
            :type="resend"
            v-if="! isLoadingBlade"
        />

        <hr class="my-4" v-if="hasRecords && ! showAddRecord"/>

        <div v-if="hasRecords && ! showAddRecord && ! isLoadingBlade">
            <base-button
                type="primary"
                @click="displayAddPage()"
            >
                <i class="fa fa-plus"></i>
                Add New Record
            </base-button>
        </div>

        <div
            class="row align-items-center"
            v-if="! isLoadingBlade && (! hasMedicalSchool || showAddRecord)"
        >

            <div class="col-lg-4">
                <base-input alternative=""
                    label="School Type"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="records.school_type"
                        :disabled="! hasMedicalSchool"
                    >
                        <option value="primary">Primary</option>
                        <option value="secondary">Secondary</option>
                        <option value="tertiary">University</option>
                        <option value="medical-school">College of Medicine</option>
                        <option value="pre-clinical-period">Pre-Clinical Period</option>
                        <option value="clinical-period">Clinical Period</option>
                    </select>
                </base-input>
            </div>

            <div class="col-lg-4">
                <base-input alternative=""
                    label="Country"
                    required
                >
                    <autocomplete
                        input-class="form-control form-control-alternative"
                        placeholder="Type Country"
                        showNoResults
                        :source="locations.countries"
                        v-model="records.country"
                        @selected="changeCountry"
                    >
                    </autocomplete>
                </base-input>
            </div>

            <div class="col-lg-4" v-if="! isOtherSchool">
                <base-input alternative=""
                    label="Name of Institution"
                    required
                >
                    <autocomplete
                        input-class="form-control form-control-alternative"
                        placeholder="Type Institution's Name"
                        showNoResults
                        :disableInput="institutions && institutions.length == 0"
                        :source="institutions"
                        resultsValue="name"
                        v-model="records.school_name"
                    >
                    </autocomplete>
                </base-input>
            </div>

            <div class="col-lg-4" v-if="isOtherSchool">
                <base-input alternative=""
                    label="Other Institution"
                    placeholder="Enter Other Institution Name"
                    input-classes="form-control-alternative"
                    v-model="records.other_school_name"
                    required
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                    label="Qualifications Obtained"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="records.qualifications_obtained"
                        @change="changeOtherQualifications()"
                    >
                        <option
                            :value="null"
                            disabled
                        >
                            --- Select One ---
                        </option>
                        <option value="mbbs">MBBS</option>
                        <option value="md">MD</option>
                        <option value="mbbch">MBBCH</option>
                        <option value="bds">BDS</option>
                        <option value="dds">DDS</option>
                        <option value="waec">WAEC</option>
                        <option value="neco">NECO</option>
                        <option value="flsc">FLSC</option>
                        <option value="others">Others (Please, specify)</option>
                    </select>
                </base-input>
            </div>
            <div class="col-lg-4" v-if="showOtherQualifications">
                <base-input alternative=""
                    label="Other Qualifications"
                    placeholder="Enter Other Qualification Name"
                    input-classes="form-control-alternative"
                    v-model="records.other_qualifications_obtained"
                    required
                />
            </div>
            <div class="col-lg-4">
                <base-input
                    label="Degree Start Date"
                    addon-left-icon="ni ni-calendar-grid-58"
                    required

                >
                    <flat-picker
                        slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="records.start_date"
                    >
                    </flat-picker>
                </base-input>
            </div>
            <div class="col-lg-4">
                <base-input
                    label="Degree End Date"
                    addon-left-icon="ni ni-calendar-grid-58"
                    required

                >
                    <flat-picker
                        slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="records.end_date"
                    >
                    </flat-picker>
                </base-input>
            </div>
            <div class="col-lg-12">
                <base-alert :type="errorType" dismissible v-if='showInputErrorStatus'>
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>
            </div>
            <div class="col-lg-12"></div>
            <div class="col-lg-12">
                <base-button
                    type="success"
                    @click="saveEduRecords()"
                >
                    <i class="fa fa-save"></i>
                    {{isloading ? 'Please Wait...' : 'Add Record'}}
                </base-button>

                <div class="right" v-if="hasRecords">
                    <base-button
                        type="danger"
                        @click="displayAddPage()"
                    >
                        <i class="fa fa-times"></i>
                        Cancel
                    </base-button>
                </div>
            </div>
        </div>


        <hr class="my-4"/>

        <div class="row">
            <div class="col-lg-12">
                <base-button
                    type="danger"
                    @click="showPreviousPage()"
                >
                    <i class="fa fa-arrow-left"></i>
                    Previous
                </base-button>
                <div class="right" v-if="hasMedicalSchool">
                    <base-button
                        type="success"
                        @click="showNextPage()"
                    >
                        Next
                        <i class="fa fa-arrow-right"></i>
                    </base-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import EduRecordsData from '../../ProfessionalData/EducationalRecords/EduRecordsData.vue';
    import flatPicker from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import swal from 'sweetalert2';// import sweet alert
    import Autocomplete from 'vuejs-auto-complete'

    export default {
        components: {
            flatPicker,
            EduRecordsData,
            Autocomplete
        },
        name: 'EduRecords',
        props: ['displayBioData', 'displaySpecData', 'resend'],
        data() {
            return {
                eduRecords: [],
                paginatedItems: [],
                records: {
                    school_type: 'medical-school',
                    school_name: null,
                    other_school_name: null,
                    qualifications_obtained: null,
                    country: null,
                    start_date: null,
                    end_date: null,
                    other_qualifications_obtained: null
                },
                pagination: {
                    total: null,
                    number: 1,
                    from: null,
                    perPage: this.$store.state.user.perPage // get per page count
                },
                institutions: [],
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                showOtherQualifications: false,
                showInputErrorStatus: false,
                isLoadingBlade: true,
                showAddRecord: false,
                config: {
                    maxDate: new Date().fp_incr(1),
                    altInput: true,// eslint-disable-next-line
                    plugins: [new monthSelectPlugin({shorthand: true, dateFormat: "Y-m-d", altFormat: "M Y"})]
                }
            };
        },
        computed: {
            ...mapGetters(['locations', 'loadingBladeUrl']),
            hasPagination() {
                return this.paginatedItems && (this.paginatedItems.length > this.pagination.perPage)
                    ? true : false;
            },// eslint-disable-next-line
            hasMedicalSchool() {// check for medical school record
                for(let school of this.paginatedItems) {
                    return (school.school_type == 'medical-school') ? true : false;
                }
            },
            hasRecords() {// check for any records
                return this.eduRecords && this.eduRecords.length > 0;
            },
            isOtherSchool() {
                let type = this.records.school_type;
                return type && (type != 'medical-school') && (type != 'pre-clinical-period') &&
                            (type != 'clinical-period') && (type != 'tertiary');
            }
        },
        methods: {
            ...mapActions(['getLocations', 'getAssessmentInstitutions', 'saveUserEduRecords',
                'getUserEducationalRecords', 'deleteUserEduRecord']), 
            displayAddPage() {
                return this.showAddRecord = ! this.showAddRecord;
            },
            changeCountry(e) {// get exact institutions
                this.records.school_name = null,
                this.records.other_school_name = null,
                this.records.school_id = null;
                this.institutions = [];
                this.preloader();
                this.getAssessmentInstitutions({ cId : e.value }).then((res) => {
                    swal.close();
                    return this.institutions = res.schools
                });
            },
            showPreviousPage() {// go to next page
                return this.displayBioData(true);
            },
            showNextPage() {// go to next page
                return this.displaySpecData(true);
            },
            loadEducationalRecords() {// get edu records
                const id = this.$store.state.user.userId;
                if(id) {
                    this.getUserEducationalRecords({'id' : id}).then((res) => {
                        this.setPages(res);
                        this.isLoadingBlade = false;
                    });
                }
            },
            setPages(res) {// set paginated function
                this.eduRecords = [];
                this.paginatedItems = res;
                this.pagination.total = this.paginatedItems.length; // get items total
                let perPage = this.pagination.perPage; // get per page count
                if(this.paginatedItems.length > perPage) {// paginate
                    let numberOfPages = Math.ceil(this.paginatedItems.length / perPage);
                    for (let index = 1; index <= numberOfPages; index++) {
                        this.eduRecords.push(this.paginatedItems[index]);
                    }
                } else {
                    this.eduRecords = this.paginatedItems;
                }
            },
            paginate() {// paginate function
                this.eduRecords = [];
                this.pagination.from = null;
                let page = this.pagination.number;
                let perPage = this.pagination.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);
                this.pagination.from = from;//get first item number
                return this.eduRecords = this.paginatedItems.slice(from, to);
            },
            changeOtherQualifications() {// change other qualifications
                let value = this.records.qualifications_obtained;
                return this.showOtherQualifications = (value == 'others') ? true : false;
            },
            saveEduRecords() {// save new edu records
                this.isloading = true;
                let data = this.validatedInputs();// validate inputs
                if(data) {// save edu records
                    this.preloader();// show loader
                    data.user_data_id = this.$store.state.user.basicProfile.id;// get user id
                    this.saveUserEduRecords(data).then((res) => {
                        this.isloading = false;
                        if(res.status) {
                            this.showErrorStatus = false;
                            this.showAddRecord = false;
                            this.loadEducationalRecords(); // load EduRecords
                            this.emptyEduRecords();
                            swal.fire("Record Added!", "School record was added successfully", "success");
                        } else {
                            swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                            this.emptyEduRecords();
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        this.emptyEduRecords();
                        swal.fire("Error Occurred!", "An error occurred, kindly reload page and try again", "warning");
                    });
                } else {
                    this.isloading = false;
                }
            },
            validatedInputs() {
                let data = this.records;
                let eduRecord = { school_type: null, start_date: null, country_id: null,
                    end_date: null, school_name: null, qualifications_obtained: null };
                eduRecord.end_date  = data.end_date == null ?
                    this.showInuptError('School\'s End Date') : data.end_date;
                eduRecord.start_date  = data.start_date == null ?
                    this.showInuptError('School\'s Start Date') : data.start_date;
                eduRecord.country_id  = data.country == null ?
                    this.showInuptError('Country') : data.country;
                // validate qualification obtained
                if((data.qualifications_obtained == null || data.qualifications_obtained == 'others')
                    && data.other_qualifications_obtained != null) {
                    eduRecord.qualifications_obtained = data.other_qualifications_obtained;
                } else if(data.qualifications_obtained != null && data.qualifications_obtained != 'others') {
                    eduRecord.qualifications_obtained = data.qualifications_obtained;
                } else if((data.qualifications_obtained == null || data.qualifications_obtained == 'others')
                    && data.other_qualifications_obtained == null) {
                    this.showInuptError('Qualification Obtained');
                }
                // validate institution obtained
                if((data.school_name == null || data.school_name == 'others')
                    && data.other_school_name != null) {
                    eduRecord.school_name = data.other_school_name;
                } else if(data.school_name != null && data.school_name != 'others') {
                    eduRecord.school_name = data.school_name;
                } else if((data.school_name == null || data.school_name == 'others')
                    && data.other_school_name == null) {
                    this.showInuptError('School\'s Name');
                }
                eduRecord.school_type = data.school_type == null ?
                    this.showInuptError('School\'s Type') : data.school_type;
                return this.isEmpty(eduRecord) ? eduRecord : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showInputErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showInputErrorStatus = false; }, 5000);
            },
            emptyEduRecords() {
                this.records.school_name = null;
                this.records.other_school_name = null;
                this.records.qualifications_obtained = null;
                this.records.country = null;
                this.records.start_date = null;
                this.records.end_date = null;
                this.records.other_qualifications_obtained = null;
                this.institutions = [];
            },
            deleteEduRecord(id) {// delete User EduRecord function
                this.preloader();// show loader
                this.deleteUserEduRecord({'id' : id}).then((res) => {
                    if(res.status) {
                        swal.fire("Record Deleted!", "School record was removed successfully", "success");
                        this.loadEducationalRecords(); // load EduRecords
                    } else {
                        swal.fire("Error Occurred!", "An error occurred while deleting, try again", "warning");
                        this.loadEducationalRecords(); // load EduRecords
                    }
                }).
                catch(() => {
                    swal.fire("Network Failure", "Reload page and try again...", "warning");
                    this.loadEducationalRecords(); // load EduRecords
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {
            this.loadEducationalRecords();// load edu records
        },
    }
</script>

<style scoped>
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
</style>